import { ActionTree } from 'vuex';
import { DashboardState } from './types';
import { RootState } from '@/types';
import { dashboardService } from '@/services/dashboard.services';
import { claimService } from '@/services/claim.services';
import { userService } from '@/services/user.services';


export const actions: ActionTree<DashboardState, RootState> = {
    getReminders({ commit }, {
        page = 1,
        perPage = 10,
        search = '',
        archived = false,
        sortBy = '',
        sortDesc = false,
        assignee = '',
        futureReminders = false,
    }): any {
        commit('setRemindersLoading');
        dashboardService.reminders(page, perPage, search, archived, sortBy, sortDesc, assignee, futureReminders)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setRemindersData', payload);
        }, (error) => {
            commit('setRemindersError', error);
        });
    },
    postReminder({ dispatch }, {
        comment,
        page = 1,
        perPage = 10,
        search = '',
        archived = false,
        sortBy = '',
        sortDesc = false,
    }): any {
        claimService.putComment(comment.id, comment)
        .then(() => {
            dispatch('getReminders', { page, perPage, search, archived, sortBy, sortDesc });
        });
    },
    getUsers({ commit }): any {
        userService.index(1, 100)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setUsers', payload);
        });
    },
};
